/*
 * @description:
 * @Author: liwg
 * @Date: 2022-07-08 14:32:48
 * @LastEditors: liwg
 * @LastEditTime: 2022-07-08 14:55:48
 */

import { defineStore } from 'pinia'
import { LOCALE } from '@/settings/localeSetting'
import { i18n } from '@/locales'
import { loadLocalePool, setHtmlPageLang } from '@/locales/helper'
import { store } from './index'

interface LangModule {
  message: Recordable
  dateLocale: Recordable
  dateLocaleName: string
}
export const useLangStore = defineStore(
  'app_locale',
  () => {
    const { portingConfig } = usePortingConfig()
    const defaultLang = window.sessionStorage.getItem('nslocale') as LocaleType
    const activeLang = ref<LocaleType>(
      portingConfig.isI18n ? defaultLang || LOCALE.ZH_CN : LOCALE.ZH_CN
    )
    const showLangText: Recordable = {
      en: 'English',
      zh_CN: '简体中文',
      zh_HK: '繁体中文'
    }

    const getAntdLocale = computed((): any => {
      const antdLocale = i18n.global.getLocaleMessage(unref(activeLang))?.antdLocale || {}
      return antdLocale
    })

    async function changeLocale(locale: LocaleType) {
      const globalI18n = i18n.global
      const currentLocale = unref(globalI18n.locale)
      if (currentLocale === locale) {
        return locale
      }

      if (loadLocalePool.includes(locale)) {
        setI18nLanguage(locale)
        return locale
      }
      const langModule = ((await import(`../locales/lang/${locale}.ts`)) as any)
        .default as LangModule
      if (!langModule) return

      const { message } = langModule

      globalI18n.setLocaleMessage(locale, message)
      loadLocalePool.push(locale)

      setI18nLanguage(locale)
      return locale
    }

    function setI18nLanguage(locale: LocaleType) {
      if (i18n.mode === 'legacy') {
        i18n.global.locale = locale
      } else {
        ;(i18n.global.locale as any).value = locale
      }
      activeLang.value = locale
      window.sessionStorage.setItem('nslocale', locale)
      setHtmlPageLang(locale)
    }

    return {
      getAntdLocale,
      showLangText,
      activeLang,
      changeLocale
    }
  },
  {
    persist: true
  }
)

export function useLocaleStoreWithOut() {
  return useLangStore(store)
}
